import "../../../src/App.css";
import Region from "../../components/Region/Region";
import AddRegion from "../../components/AddRegion/AddRegion";
import RegionList from "../../components/RegionList/RegionList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function RegionMaster() {
  const [regionResponse, setRegionResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [filterCityData, setFilterCityData] = useState(false);
  const [regionId, setRegionId] = useState();
  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add Region";
  const heading = "Region List";

  function tokenStorage(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}Adminget/GETRegion?region_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setRegionResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  useEffect(() => {
    tokenStorage();
  }, []);

  const GetId = (param) => {
    setRegionId(param);    
  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Region List| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Region List</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {openAddProfile ? <AddRegion tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} /> : null}
                {openProfile ? <Region tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} regionId={regionId} /> : null}
                <RegionList
                  regionResponse={regionResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile = {openAddProfile} 
                  setOpenAddProfile = {setOpenAddProfile}
                />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegionMaster;
